import * as Types from '../constants/actionTypes';
const initState = {
    portalUserCompanies: [],
    error: '',
}
export default (state = initState, action) => {
    switch (action.type) {
        case Types.PORTAL_USER_COMPANIES_LIST:
            return {
                ...state,
                portalUserCompanies: action.payload,
                error: '',
            }
        case Types.PORTAL_USER_COMPANIES_ADD:
            state.portalUserCompanies = state.portalUserCompanies.concat(action.payload);
            return {
                ...state,
                error: '',
            }
        case Types.PORTAL_USER_COMPANIES_REMOVE:
            state.portalUserCompanies.splice(action.payload, 1);
            return {
                ...state,
                error: '',
            }
        case Types.PORTAL_USER_COMPANIES_REMOVE_ALL:
            state.portalUserCompanies = [];
            return {
                ...state,
                error: '',
            }
        case Types.PORTAL_USER_COMPANIES_ERR:
            return {
                ...state,
                error: action.error,
            }
        default:
            return state;
    }
};